export default {"src":"/_next/static/media/USB.67d46752.svg","height":18,"width":18};